// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"fe1afb42","455":"422679a2","977":"a170a410"}[chunkId] + ".chunk.js";
};